module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('router-link', {
    staticClass: "Main_left",
    attrs: {
      "slot": "left",
      "to": "/user/gongdan"
    },
    slot: "left"
  }), _vm._v("\n    工单详情\n  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('ul', {
    staticClass: "detail-box margin-bottom-20"
  }, [_c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("工单编号 " + _vm._s(_vm.content.id))]), _vm._v(" "), _c('span', {
    staticClass: "state-icon pull-right",
    class: {
      'text-red': _vm.content.state === '待分配', 'text-orange': _vm.content.state === '处理中', 'text-primary': _vm.content.state === '已答复', 'text-green': _vm.content.state === '已结束'
    }
  }, [_vm._v(_vm._s(_vm.content.state))])]), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "detail-row remark"
  }, [_c('label', [_vm._v("问题标题")]), _vm._v("\n          " + _vm._s(_vm.content.gd_content) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("提交时间")]), _vm._v("\n          " + _vm._s(_vm.content.gd_time) + "\n        ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "order-dialogue"
  }, [_c('li', {
    staticClass: "user-conversation clearfix"
  }, [_c('span', {
    staticClass: "user-head-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogue-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.content.gd_content))]), _c('br'), _vm._v(" "), (_vm.content.fujian_1) ? _c('img', {
    staticClass: "margin-top-20",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "src": _vm.content.fujian_1
    },
    on: {
      "click": function($event) {
        _vm.ShowImg(_vm.content.fujian_1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.fujian_2) ? _c('img', {
    staticClass: "margin-top-20",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "src": _vm.content.fujian_2
    },
    on: {
      "click": function($event) {
        _vm.ShowImg(_vm.content.fujian_1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.fujian_3) ? _c('img', {
    staticClass: "margin-top-20",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "src": _vm.content.fujian_3
    },
    on: {
      "click": function($event) {
        _vm.ShowImg(_vm.content.fujian_1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "margin-top-10"
  }, [_vm._v(_vm._s(_vm.content.gd_time))])])]), _vm._v(" "), _vm._l((_vm.reply), function(item) {
    return _c('li', {
      staticClass: "user-conversation clearfix"
    }, [_c('span', {
      staticClass: "user-head-img"
    }), _vm._v(" "), _c('div', {
      staticClass: "dialogue-content"
    }, [_c('span', [_vm._v(_vm._s(item.gd_content))]), _c('br'), _vm._v(" "), (item.fujian_1) ? _c('img', {
      staticClass: "margin-top-20",
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "src": item.fujian_1
      },
      on: {
        "click": function($event) {
          _vm.ShowImg(item.fujian_1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.fujian_2) ? _c('img', {
      staticClass: "margin-top-20",
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "src": item.fujian_2
      },
      on: {
        "click": function($event) {
          _vm.ShowImg(item.fujian_1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.fujian_3) ? _c('img', {
      staticClass: "margin-top-20",
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "src": item.fujian_3
      },
      on: {
        "click": function($event) {
          _vm.ShowImg(item.fujian_1)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "margin-top-10"
    }, [_vm._v(_vm._s(item.gd_time))])])])
  }), _vm._v(" "), (_vm.content.state != '已结束') ? _c('div', [_c('x-button', {
    staticStyle: {
      "width": "47%",
      "display": "inline-block",
      "margin-top": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.GongdanClose($event)
      }
    }
  }, [_vm._v("完成工单")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "width": "47%",
      "display": "inline-block",
      "margin-top": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Reply($event)
      }
    }
  }, [_vm._v("继续留言")])], 1) : _vm._e(), _vm._v(" "), (_vm.content.state === '已结束') ? _c('div', [_c('x-button', {
    staticStyle: {
      "width": "47%",
      "display": "inline-block",
      "margin-top": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Tousu($event)
      }
    }
  }, [_vm._v("一键投诉")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "color": "#fff",
      "width": "47%",
      "display": "inline-block",
      "margin-top": "0"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.assbtn
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Assess($event)
      }
    }
  }, [_vm._v("评价工单")])], 1) : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('x-dialog', {
    staticClass: "dialog-demo",
    attrs: {
      "hide-on-blur": ""
    },
    model: {
      value: (_vm.showHideOnBlur),
      callback: function($$v) {
        _vm.showHideOnBlur = $$v
      },
      expression: "showHideOnBlur"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.imgsrc
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showHideOnBlur = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-107bb17e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/workorder.vue
// module id = HJWa
// module chunks = 1